import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { greenScaleColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return greenScaleColors[4];
  }
  if (value < 50) {
    return greenScaleColors[3];
  }
  if (value < 75) {
    return greenScaleColors[1];
  }
  return greenScaleColors[0];
};

const RecursosTransicionSecond = ({ user, background, number }) => {
  const autoeficacia = (parseFloat(user['RECTR_AUT']) / 5) * 100;
  const optimismo = (parseFloat(user['RECTR_OPT']) / 5) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2 style={{ marginBottom: 0 }}>5.1. Autoeficacia</h2>
          <p className='justified'>
            Los sentimientos de autoeficacia se relacionan con la{' '}
            <strong>confianza en las propias capacidades</strong> para enfrentar
            los cambios y desafíos que implican la nueva etapa escolar, así como
            para poner los esfuerzos necesarios para tener éxito y lograr las
            metas que te propongas en esta nueva etapa.
          </p>
          <p className='justified'>
            Resultados en
            <Span strong color={greenScaleColors[4]}>
              {' '}
              VERDE{' '}
            </Span>
            sugieren que tienes altos sentimientos de autoeficacia, lo que te
            ayudará a enfrentar de forma positiva la transición escolar.
          </p>
          <p className='justified'>
            Resultados en{' '}
            <Span strong color={greenScaleColors[0]}>
              GRIS
            </Span>{' '}
            sugieren que puedes sentirte menos confiado/a en tus capacidades
            para afrontar el nuevo desafío. Para aumentar este tipo de
            sentimientos,{' '}
            <strong>
              es importante que identifiques y valores los logros que has tenido
              hasta ahora y te propongas metas razonables para el futuro
            </strong>
            .
          </p>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={autoeficacia}
                  backColor={() => getColor(100 - autoeficacia)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{autoeficacia.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>

          <br />

          <h2 style={{ marginBottom: 0 }}>5.2. Optimismo</h2>
          <p className='justified'>
            Los sentimientos de optimismo se relacionan con la capacidad para{' '}
            <strong>
              mantener una visión positiva respecto de los cambios y nuevos
              desafíos
            </strong>{' '}
            que te tocará enfrentar en los próximos años. El contar con una
            visión optimista contribuye a una mayor motivación por los estudios,
            una mejor disposición para adaptarse a los cambios y un mayor
            bienestar emocional.
          </p>
          <p className='justified'>
            Resultados en
            <Span strong color={greenScaleColors[4]}>
              {' '}
              VERDE{' '}
            </Span>
            sugieren que tienes altos sentimientos de optimismo, logras ver el
            lado positivo de las cosas que pasan en el colegio y esperas que la
            nueva etapa escolar sea una gran experiencia.
          </p>
          <p className='justified'>
            Resultados en{' '}
            <Span strong color={greenScaleColors[0]}>
              GRIS
            </Span>{' '}
            sugieren que puedes tener una perspectiva menos positiva respecto de
            los nuevos desafíos y cambios de esta etapa escolar. Es importante
            que puedas desarrollar una visión optimista,{' '}
            <strong>
              animándote a reconocer y enfocarte en los aspectos positivos de
              las situaciones, incluso en medio de los desafíos, así como fijar
              metas realistas, celebrando los logros, por pequeños que sean
            </strong>
            .
          </p>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={optimismo}
                  backColor={() => getColor(100 - optimismo)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{optimismo.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default RecursosTransicionSecond;
